import React, { memo } from "react";
import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://minio-i8s8so84skc8oks0k8ogo80o.148.135.137.84.sslip.io/assets/salimar_images/logo.png";

const SiteHeader = ({ className = "loginsignup" }) => (
  <div className={className}>
    <Link to="/">
      <img src={LOGO_URL} alt="logo" className="logo" fetchPriority="high" />
    </Link>
    <Link to="/login_signup">Login/Signup</Link>
  </div>
);

export default memo(SiteHeader);
